var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-expansion',{attrs:{"components":_vm.customComponents,"disabled":_vm.loading},on:{"save-required":_vm.handleSaveRequired},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}})
}
var staticRenderFns = []

export { render, staticRenderFns }